export { default } from "./QuizToggleAnswersButton";
